import type { AuthObject } from '@white-label-types/auth';
import { Auth0Client } from '@auth0/auth0-spa-js';

export const refreshUserWrapper = async (
  auth0Client: Auth0Client | null,
  authInstance: AuthObject
) => {
  const user = await auth0Client?.getUser();
  const isAuthenticated = await auth0Client?.isAuthenticated();

  authInstance.user =  user || null
  authInstance.isAuthenticated =  isAuthenticated || false;
};
